import proxy from "api/proxy";
import moves from "./ModelStockMove";
import { getStorage, setStorage } from "store/local";
import tools from "tools/dates";
import AddProduct from "../Components/AddProduct";

let today = tools.dateToday();
const ctxSession = getStorage("ctxSession");

function ComponentAddProduct({ record }) {
  return AddProduct("stock.shipment.out.return", record);
}

function onChangeWarehouse(rec, store) {
  store.warehouse_input = rec.warehouse["input_location"];
  store.warehouse_input = store.customer["customer_location."].id;
  rec.warehouse_storage = rec.customer["customer_location."];
  store.warehouse_storage = rec.warehouse["storage_location"];
}
const getAddress = (value, record) => {
  console.log(record, "record");
  const party_id = record?.customer?.id;

  let dom = party_id ? [["party", "=", party_id]] : [];
  if (value > 2) {
    dom.push(["rec_name", "ilike", `%${value}%`]);
  }
  return dom;
};
async function onChangeCustomer(rec, store) {
  const _session = { ...getStorage("ctxSession") };
  _session.locations = [rec.customer.customer_location];
  await setStorage("ctxSession", _session);
  if (rec.customer.addresses.length > 0) {
    store.contact_address = rec.customer.addresses[0];
  }
}
const visibleMoves = (field, record) => {
  return record?.state === "draft" || !record.state;
};
const visibleOutgoingMoves = (field, record) => {
  return (
    record.state === "waiting" ||
    record.state === "assigned" ||
    record.state === "done"
  );
};

const onPrintBrowser = async (record) => {
  console.log(record, "record");

  const {
    planned_date,
    from_location,
    effective_date,
    number,
    state,
    warehouse,
    contact_address,
  } = record;

  const datePlanned = new Date(planned_date).toLocaleDateString("es-CO");
  const dateEffective = new Date(effective_date).toLocaleDateString("es-CO");

  const lineas = (record["incoming_moves."] || [])
    .map((move, index) => {
      return `
      <tr>
        <td>${move.product?.rec_name || move.product?.name} x ${move.quantity}</td>
      </tr>
    `;
    })
    .join("");

  const contenidoHTML = `
    <html>
      <head>
        <title>Comprobante de Devolución</title>
        <style>
          body {
            font-family: sans-serif;
            font-size: 2.8mm;
            padding: 20px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
            font-size: 2.2mm;
          }
          th, td {
            border: 1px solid #333;
            padding: 5px;
            text-align: left;
            font-size: 2.5mm;
          }
          .firma {
            margin-top: 60px;
            text-align: center;
          }
          .firma-linea {
            border-top: 1px solid #000;
            width: 200px;
            margin: 0 auto;
            margin-top: 40px;
          }
        </style>
      </head>
      <body>
        <h2>Comprobante de Devolución</h2>
        <p><strong>Fecha planeada:</strong> ${datePlanned}</p>
        <p><strong>Fecha Efectiva:</strong> ${dateEffective}</p>
        <p><strong>Desde:</strong> ${contact_address?.rec_name}</p>
        <p><strong>Hacia:</strong> ${warehouse?.rec_name}</p>
        <p><strong>Número:</strong> ${number}</p>
        <p><strong>Estado:</strong> ${state}</p>

        <h3>Líneas de Productos</h3>
        <table>
          <thead>
            <tr>
              <th>Producto</th>
             
            </tr>
          </thead>
          <tbody>
            ${lineas}
          </tbody>
        </table>

        <div class="firma">
          <div class="firma-linea"></div>
          <p>Firma Responsable</p>
        </div>
      </body>
    </html>
  `;

  const ventana = window.open("", "", "width=800,height=600");
  ventana.document.open();
  ventana.document.write(contenidoHTML);
  ventana.document.close();
  ventana.focus();
  ventana.print();
};

const visibleSave = (name, record) => {
  let res = false;
  if (!record.state) {
    res = true;
  }
  return res;
};
const visibleReceive = (name, record) => {
  let res = false;
  if (record.state === "draft" && record.number) {
    res = true;
  }
  return res;
};
const visibleDone = (name, record) => {
  let res = false;
  if (record.state === "received" && record.number) {
    res = true;
  }
  return res;
};

const visiblePrint = (name, record) => {
  let res = false;
  if (record.state === "done" && record.number) {
    res = true;
  }
  return res;
};
const getView = (config) => {
  const warehouse = config?.warehouse;
  const input_location = warehouse?.input_location;
  const storage_location = warehouse?.storage_location;

  let DictCtxView = {
    model: "stock.shipment.out.return",
    // model: "stock.shipment.internal",
    selectable: true,
    activeSearch: true,
    limit: 50,
    domain: [],
    form_action: ["save", "edit", "add"],
    table_action: ["open", "add"],
    webfields: {
      customer: {
        type: "many2one",
        model: "party.party",
        required: true,
        attrs: ["addresses", "customer_location", "customer_location.name"],
        withChange: onChangeCustomer,
        // readOnly: true,
        searchable: true,
      },
      contact_address: {
        type: "many2one",
        model: "party.address",
        recSearch: getAddress,
        // withChange: onChangeAddress,
        required: true,
        // readOnly: getReadonly,
        readOnly: false,
      },
      number: { type: "char", readOnly: true, searchable: true },
      reference: { type: "char", readOnly: false },
      effective_date: {
        type: "date",
        default: today,
        // readOnly: true,
      },
      planned_date: {
        type: "date",
        default: today,
        readOnly: true,
      },
      state: {
        type: "char",
        readOnly: true,
        translate: true,
      },
      invoice_state: {
        type: "char",
        readOnly: true,
        translate: true,
      },
      warehouse: {
        type: "many2one",
        model: "stock.location",
        default: warehouse,
        readOnly: true,
      },

      // storage_location WAREHOUSE
      warehouse_input: {
        type: "many2one",
        model: "stock.location",
        default: input_location,
        readOnly: false,
      },
      // input_location WAREHOUSE
      warehouse_storage: {
        type: "many2one",
        model: "stock.location",
        default: storage_location,
        readOnly: false,
      },
      moves: {
        type: "one2many",
        model: "stock.move",
        ctxView: moves,
        required: true,
        readOnly: { state: ["quotation"] },
        visible: visibleMoves,
      },
      confirm: {
        type: "button",
        button_method: "receive",
        visible: visibleSave,
        onSuccessMsg: "Devoluición de envío confirmada!",
        color: "green",
      },
      receive: {
        type: "button",
        button_method: "receive",
        visible: visibleReceive,
        onSuccessMsg: "devolución de envío recibida!",
        color: "green",
      },
      done: {
        type: "button",
        button_method: "done",
        visible: visibleDone,
        onSuccessMsg: "Devolución de envío terminada!",
        color: "green",
      },
      print: {
        type: "button",
        method: onPrintBrowser,
        visible: visiblePrint,
        color: "green",
      },
      reference: {
        type: "custom_button",
        model: "stock.shipment.out.return",
        // readOnly: true,
        Component: ComponentAddProduct,
        // searchable: true,
      },
      incoming_moves: {
        type: "one2many",
        model: "stock.move",
        ctxView: moves,
        visible: visibleOutgoingMoves,
      },
    },
    webform: [
      { name: "number" },
      { name: "state" },
      { name: "effective_date" },
      { name: "planned_date" },
      { name: "customer" },
      { name: "contact_address", width: "20%" },
      { name: "warehouse" },
      { name: "reference" },
      { name: "moves" },
      { name: "incoming_moves" },
      { name: "confirm" },
      { name: "receive" },
      { name: "done" },
      { name: "print" },
    ],
    webtree: [
      { name: "number", width: "20%" },
      { name: "customer", width: "20%" },
      // { name: "reference", width: "20%" },
      // { name: "party", width: "20%" },
      { name: "effective_date", width: "20%" },
      { name: "planned_date", width: "20%" },
      { name: "state", width: "20%" },
      // { name: "warehouse", width: "20%" },
      // { name: "warehouse_input", width: "20%" },
    ],
  };

  return DictCtxView;
};

export default { ctxView: getView };
